import {Api} from "./Api.js";
import {utils} from "../utils";

const api = new Api();
window.languages = [];

/** Класс от которого наследуются остальные классы */
export class DefaultShopClass {
	constructor() {
		this.$cartCount = $(".js-count");
		this.eventId = null;
		this.$html = $("html");
		this.lang = this.$html.attr("lang");
		this.isDesktop = window.matchMedia("(min-width: 768px)");
		this.subEventId = null;
		this.$modal = $("#js-popup-modal");
		this.$overlay = $("#js-overlay");
		this.$modalContent = this.$modal.find(".modal-body");
		this.$items = null;
		this.$message = null;
		this.languages = languages;
	}

	getCartCount(eventId = 0) {
		return api.getCartCount(eventId).then(res => {
			if (!res.length) {
				this.$cartCount.text(0).hide();
				return false;
			}
			let count = 0;
			$.each(res, (index, order) => {
				const countTickets = order.count_tickets;
				count += countTickets;
			});

			if (eventId && res.length) {
				const order = $(`.js-order[data-event="${eventId}"]`);
				const commission = order.find(".order__commission");
				if (res[0].commission) {
					commission.show();
					order.find(".js-commission").text(res[0].commission);
				}
			}

			if (count) {
				this.$cartCount.text(count).show();
			} else {
				this.$cartCount.hide();
			}
			return res;
		});
	}

	/**
	 * Получить все переводы
	 * @return {Promise}
	 */
	getLanguages() {
		const languagesFromStorage = utils.getObjectFromSessionStorage("languages");

		if (languagesFromStorage && languagesFromStorage.main.lang) {
			if (this.lang === languagesFromStorage.main.lang) {
				/* Возвращаем переводы с хранилища */
				return new Promise(resolve => {
					window.languages = languagesFromStorage;
					resolve(languages);
				});
			}
		}

		/* TODO: Поддержка для старых проектов - ПЕРЕДЕЛАТЬ и ТЕСТИТЬ */
		if (languagesFromStorage && languagesFromStorage.date.version) {
			if (window.languagesVersion === languagesFromStorage.date.version) {
				/* Возвращаем переводы с хранилища */
				return new Promise(resolve => {
					window.languages = languagesFromStorage;
					resolve(languages);
				});
			}
		}

		/* Иначе запрашиваем новые */
		return this.getAllDictionary(this.lang).then(res => {
			window.languages = res;
			utils.setObjectToSessionStorage("languages", res);
			return res;
		});
	}

	getWord(path, word) {
		return window.languages[path][word]
			? this.lang === "en"
				? word
				: window.languages[path][word]
			: word;
	}

	getPrices(view_id = 0, event_id = false) {
		if (!event_id) event_id = this.eventId;

		return api.getPrices(event_id, view_id);
	}

	getSvg(view_id, needOverlay) {
		return api.getSvg(this.eventId, view_id, needOverlay);
	}

	getSvgPrices(eventId = this.eventId, view_id, needOverlay) {
		return api.getSvgPrices(eventId, view_id, needOverlay);
	}

	getPlacesSvg(view_id) {
		return api.getPlacesSvg(this.subEventId, view_id);
	}

	addToCart(sid) {
		return api.addToCart(this.eventId, sid);
	}

	handleRemoveFromCart(sid, uid) {
		return api.removeFromCart(this.eventId, sid, uid);
	}

	handlePromocode(orderId, code) {
		return api.setPromocode(orderId, code);
	}

	/**
	 * Получение бонусов
	 * @return {Promise}
	 */
	getBonuses() {
		return api.getBonuses();
	}

	getOrderBonuses(orderId) {
		return api.getOrderBonuses(orderId);
	}

	/**
	 * Списание бонусов
	 * @return {Promise}
	 */
	payWithBonuses(order_id, bonuses) {
		return api.payWithBonuses(order_id, bonuses);
	}

	undistributionBonuses(order_id) {
		return api.undistributionBonuses(order_id);
	}

	cancelOrder() {
		return api.cancelOrder(this.eventId);
	}

	removeEventFromOrder(orderId) {
		return api.removeEventFromOrder(this.eventId, orderId);
	}

	search({...data}) {
		return api.search(data);
	}

	addAllEvents() {
		return api.addAllEvents(this.eventId);
	}

	removeAllEvents() {
		return api.removeAllEvents(this.eventId);
	}

	addSubscriptionEvent() {
		return api.addEvent(this.eventId, this.subEventId);
	}

	removeSubscriptionEvent() {
		return api.removeEvent(this.eventId, this.subEventId);
	}

	getSubscriptionCartCount(needOverlay) {
		return api.getSubscriptionCartCount(this.eventId, this.subEventId, needOverlay);
	}

	getPlaces() {
		return api.getPlaces(this.subEventId);
	}

	getSubscriptionPlace(sub_event_id) {
		return api.getSubscriptionPlace(this.eventId, sub_event_id);
	}

	getSubscriptionChange(name) {
		return api.getSubscriptionChange(this.eventId, name);
	}

	getChangeSeats() {
		return api.getChangeSeats(this.eventId, this.subEventId);
	}

	addToSubscriptionCartApi(sid) {
		return api.addToSubscriptionCart(this.eventId, this.subEventId, sid);
	}

	removeFromSubscriptionCartApi(event_id, sub_event_id, sid) {
		return api.removeFromSubscriptionCart(this.eventId, this.subEventId, sid);
	}

	getAllDictionary(lang) {
		return api.getAllDictionary(lang);
	}

	getPlacesSvg(view_id) {
		return api.getPlacesSvg(this.subEventId, view_id);
	}

	removeSubscriptionEventSids() {
		return api.removeEventSids(this.eventId, this.subEventId);
	}

	splitAdd(sid) {
		return api.splitAdd(this.eventId, sid);
	}

	splitRemove(sid) {
		return api.splitRemove(this.eventId, sid);
	}

	splitGetViews() {
		return api.splitGetViews();
	}

	deleteServiceTicket(serviceId, uid) {
		return api.deleteServiceTicket(serviceId, uid);
	}

	deleteServiceFromOrder(serviceId, count) {
		return api.deleteServiceFromOrder(serviceId, count);
	}

	getZones(eventId) {
		return api.getZones(eventId || this.eventId);
	}

	removeFullCart() {
		return api.removeFullCart();
	}

	subscribeToEvent(event_id) {
		return api.subscribeToEvent(event_id);
	}

	unsubscribeToEvent(event_id) {
		return api.unsubscribeToEvent(event_id);
	}

	checkSubscribeOfEvent(event_id) {
		return api.checkSubscribeOfEvent(event_id);
	}

	requestTicketReturn(orderId, eventId) {
		return api.ticketReturn(orderId, eventId);
	}
}
